
import React from 'react';
import { Button } from '@/components/ui/button';
import { Pencil, X } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { Task } from '@/types/task';

interface TaskHeaderProps {
  isAdmin: boolean;
  onDelete: (taskId: string) => void;
  taskId: string;
  task?: Task;
  onEdit?: () => void;
}

export const TaskHeader = ({ isAdmin, onDelete, taskId, task, onEdit }: TaskHeaderProps) => {
  const { user, profile } = useAuth();
  const isUserAdmin = profile?.role === 'admin';

  if (!isUserAdmin) return null;

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent the event from bubbling up to the card
    onDelete(taskId);
  };

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent the event from bubbling up to the card
    if (onEdit) onEdit();
  };

  return (
    <div className="flex items-center justify-end gap-2 mb-2">
      <Button
        variant="ghost"
        size="icon"
        className="text-gray-400 hover:text-gray-700 h-6 w-6"
        onClick={handleEdit}
      >
        <Pencil className="h-4 w-4" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        className="text-gray-500 hover:text-red-500 h-6 w-6"
        onClick={handleDelete}
      >
        <X className="h-4 w-4" />
      </Button>
    </div>
  );
};
